export default __webpack_public_path__ + "static/media/resulta.55c57351.svg";